export default "__VITE_ASSET__a764bf2c__"